/**
  * The type of header to display.
  */
export enum HeaderKind {
    None = 1,
    Small,
    Jumbo
}



// WEBPACK FOOTER //
// ./Client/v4/Utility/HeaderKind.ts